import type { SafeParseError } from 'zod';

/**
 * Flattens a zod failure into `{ field: i18nKey }` for MUI `helperText`.
 *
 * Only messages that are already i18n keys are passed through; anything else
 * falls back to a generic key, so a schema message that is not a key can never
 * reach the screen as raw English.
 */
export function zodFieldErrors(result: SafeParseError<unknown>): Record<string, string> {
  const errors: Record<string, string> = {};

  for (const issue of result.error.issues) {
    const field = issue.path.join('.');
    if (field && !errors[field]) {
      errors[field] = issue.message.startsWith('validation.')
        ? issue.message
        : 'validation.invalid';
    }
  }

  return errors;
}
